import React from 'react';
import { FadeIn } from './FadeIn';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative flex flex-col items-center bg-navy-gradient bg-music-notes bg-grain overflow-hidden pt-6 pb-12 md:pt-10 md:pb-16" data-id="element-100">
      <div className="w-full max-w-3xl mx-auto px-5 content-relative flex flex-col items-center text-center" data-id="element-101">
        {/* Label */}
        <FadeIn delay={0.1} data-id="element-102">
          <span className="inline-block text-gold tracking-[0.2em] text-xs sm:text-sm font-bold uppercase mb-4 border border-gold/30 px-4 py-1.5 rounded-full bg-navy-800/50 backdrop-blur-sm" data-id="element-103">
            🎹 PIANO LISTO
          </span>
        </FadeIn>

        {/* Headline */}
        <FadeIn delay={0.15} data-id="element-104">
          <h1 className="font-display font-bold text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.1] text-white mb-6" data-id="element-105">
            Tu año de piano,
            <br data-id="element-106" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-light via-gold to-gold-dark" data-id="element-107">
              resuelto.
            </span>
          </h1>
        </FadeIn>

        {/* Product Mockup Image — prominent, centered */}
        <FadeIn delay={0.2} data-id="element-108">
          <div className="relative w-full max-w-sm sm:max-w-md md:max-w-lg mx-auto mb-8" data-id="element-109">
            {/* Decorative glow behind image */}
            <div className="absolute inset-0 bg-gold/15 blur-[80px] rounded-full scale-90 pointer-events-none" data-id="element-110"></div>
            <img src="https://cdn.magicpatterns.com/uploads/6DoWmWfVFQJDUfHjHoYGWA/hf_20260426_230604_a63ca059-0ec8-4de7-9e09-4cace3681fb8_(1).png" alt="MegaPack Piano Listo - 6 tomos" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-111" />
          </div>
        </FadeIn>

        {/* Promise / Subhead */}
        <FadeIn delay={0.25} data-id="element-112">
          <p className="font-accent italic text-lg sm:text-xl md:text-2xl text-gold-light mb-4 leading-snug" data-id="element-113">
            "Listo para usar. Sin buscar más. Sin improvisar. Sin perder
            domingos."
          </p>
        </FadeIn>

        {/* Body paragraph */}
        <FadeIn delay={0.3} data-id="element-114">
          <p className="text-sm sm:text-base md:text-lg text-gray-300 mb-6 max-w-xl mx-auto leading-relaxed" data-id="element-115">
            El sistema para profesores de piano en Argentina: año completo listo
            (planificación + repertorio + técnica + teoría + recital +
            comunicación con familias), sin buscar ni armar desde cero.
          </p>
        </FadeIn>

        {/* CTA Button */}
        <FadeIn delay={0.35} className="w-full max-w-md" data-id="element-116">
          <button onClick={scrollToPricing} className="w-full bg-gradient-to-r from-gold to-gold-dark hover:from-gold-light hover:to-gold text-navy-900 font-bold text-base sm:text-lg md:text-xl py-4 px-6 rounded-xl shadow-[0_0_25px_rgba(212,180,100,0.4)] hover:shadow-[0_0_35px_rgba(212,180,100,0.6)] transition-all duration-300 transform hover:-translate-y-1 animate-pulse-slow flex items-center justify-center gap-2 whitespace-nowrap" data-id="element-117">
            🎹 → Quiero mi pack ahora
          </button>
        </FadeIn>

        {/* Badges */}
        <FadeIn delay={0.4} data-id="element-118">
          <div className="flex flex-wrap justify-center gap-2 sm:gap-3 mt-6" data-id="element-119">
            {['📄 PDF', '⚡ Inmediato', '🇦🇷 Argentina'].map((badge, i) => <span key={i} className="text-xs sm:text-sm font-medium bg-white/5 border border-white/10 px-3 py-1.5 rounded-full text-gray-200" data-id="element-120">
                {badge}
              </span>)}
          </div>
        </FadeIn>

        {/* Trust line */}
        <FadeIn delay={0.45} data-id="element-121">
          <div className="mt-5 flex flex-col sm:flex-row flex-wrap items-center justify-center gap-1.5 sm:gap-3 text-xs sm:text-sm text-gray-400 opacity-80" data-id="element-122">
            <span data-id="element-123">🛡️ Garantía 7 días sin preguntas</span>
            <span className="hidden sm:inline text-gold/30" data-id="element-124">·</span>
            <span data-id="element-125">🔒 Pago 100% seguro</span>
            <span className="hidden sm:inline text-gold/30" data-id="element-126">·</span>
            <span data-id="element-127">💳 Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </FadeIn>
      </div>
    </section>;
}